<template>
  <div>
    <section class="section-container-color">
      <div class="container section-container-title">
        <div class="row justify-content-center">
          <div class="col-12 col-lg-10 col-xl-12">
            <h3 class="text-transparencia font-weight-700">
              Examen para la Obtención de la Constancia de Capacitación en Observación Electoral 2026
            </h3>
          </div>
        </div>

        <app-loader v-if="isLoading" :text="loadingText" />

        <div class="row justify-content-center" v-if="ready && !isLoading">
          <div class="col-12 col-lg-10 col-xl-12">

            <div v-if="!finished" class="exam-info-box p-3 rounded mb-2">
              <strong>Importante:</strong> No podrás retroceder a preguntas anteriores.<br/>
              No actualice ni cierre la página durante el examen, ya que perderá su progreso.
            </div>

            <div class="mb-2">
              <div class="progress" style="height: 12px;">
                <div
                  class="progress-bar"
                  role="progressbar"
                  :style="{ width: progressPercent + '%' }"
                  :aria-valuenow="progressPercent"
                  aria-valuemin="0"
                  aria-valuemax="100"
                ></div>
              </div>
            </div>

            <div v-if="showSelectionError && !isTimeUp" class="alert alert-danger text-center py-2 mb-2">
              <i class="fas fa-exclamation-circle mr-2"></i> Selecciona una opción antes de continuar.
            </div>

            <div v-if="isTimeUp" class="alert alert-danger text-center py-2 mb-2">
              <i class="fas fa-exclamation-circle mr-2"></i> El tiempo ha expirado para esta pregunta. Haz clic en "Siguiente" para continuar.
            </div>

            <div class="card shadow-3 mb-2">
              <div class="card-body p-5">
                <div class="d-flex align-items-center justify-content-between mb-2">
                  <h4 class="text-description fs-16 lh-141 mb-0 font-weight-medium">
                    Pregunta {{ currentIndex + 1 }} de {{ totalQuestions }}
                  </h4>
                  <span class="time-badge" :class="timeState" :style="{fontSize: '20px'}">
                    <i class="fas fa-hourglass-half mr-1" :class="{ 'hourglass-flip': !isTimeUp }"></i>
                    {{ timeLeft }}s
                  </span>
                </div>
                <pregunta-respuesta-multiple
                  :question="currentQuestion"
                  v-model="selectedOptionId"
                  :disabled="isLocked"
                />
              </div>
            </div>

            <div class="d-flex justify-content-center mt-3">
              <button
                v-if="isTimeUp"
                class="btn btn-outline-secondary font-weight-bold py-4 px-12"
                @click="nextQuestion"
              >
                Siguiente
              </button>

              <button
                v-else
                class="btn btn-transparencia font-weight-bold py-4 px-12"
                :disabled="isLocked"
                @click="confirmAnswer"
              >
                {{ currentIndex + 1 == totalQuestions ? "Finalizar" : "Siguiente" }}
              </button>
            </div>
          </div>
        </div>

      <div class="row justify-content-center mt-4" v-if="finished && !isLoading">
        <div class="col-12 col-lg-10 col-xl-12">
          <div class="card shadow-3">
            <div class="card-body p-4 p-md-5 text-center">
              <div class="result-badge mb-3" :class="passed ? 'ok' : 'fail'">
                <i class="fas mr-2" :class="passed ? 'fa-check-circle' : 'fa-times-circle'"></i>
                {{ passed ? "APROBADO" : "DESAPROBADO" }}
              </div>

              <h4 class="font-weight-800 mb-2">
                Resultado final
              </h4>

              <p class="text-muted mb-4">
                Obtuviste <strong>{{ score }}</strong> de <strong>{{ totalQuestions }}</strong> respuestas correctas ({{ percent }}%).
                Puntaje mínimo: <strong>{{ passPoints }}</strong>.
              </p>

              <div v-if="passed" class="mb-4">
                <p class="mb-0">
                  ¡Felicitaciones! Has aprobado el examen y puedes descargar tu constancia.
                </p>
              </div>

              <div v-else class="mb-4">
                <p class="mb-0">
                  Te invitamos a reforzar el contenido e intentarlo nuevamente.
                </p>
              </div>

              <div class="d-flex justify-content-center flex-wrap">
                <button
                  v-if="passed"
                  class="btn btn-transparencia font-weight-bold mr-2 mb-2"
                  @click="downloadConstancia"
                >
                  <i class="fas fa-file-download fa-fw mr-1"></i> Descargar constancia (PDF)
                </button>
                <button
                  v-if="!passed"
                  class="btn btn-transparencia font-weight-bold mr-2 mb-2"
                  @click="restartExam"
                >
                  <i class="fas fa-redo fa-fw mr-1"></i> Intentar nuevamente
                </button>
                <button class="btn btn-outline-secondary font-weight-bold mb-2" @click="goBackToCert">
                  <i class="fas fa-arrow-left fa-fw mr-1"></i> Volver
                </button>
              </div>

              <small class="text-muted d-block mt-3 font-weight-bold" v-if="passed">
                Recuerda descargar tu constancia antes de cerrar esta ventana. </br>
                Una vez cerrada, no será posible recuperar el archivo desde esta sesión.
              </small>
            </div>
          </div>
        </div>
      </div>
      </div>
    </section>
  </div>
</template>

<script>
import preguntaRespuestaMultiple from "@/components/examenes/pregunta-respuesta-multiple.vue";
import { PDFDocument, rgb, StandardFonts } from "pdf-lib";
import AppLoader from "@/components/share/loader.vue";
import Swal from "sweetalert2";

export default {
  name: "examen",
  metaInfo: { title: "Examen" },
  components: { preguntaRespuestaMultiple, AppLoader },
  data: () => ({
    registro: {
      nombresApellidos: "",
      correo: "",
      telefono: "",
      dni: "",
      region: "",
      provincia: "",
      distrito: "",
      regionExtranjero: ""
    },
    isLoading: false,
    loadingText: "",
    ready: false,
    finished: false,
    finishedAt: null,

    bank: [],
    examQuestions: [],
    answers: [],
    currentIndex: 0,

    totalTime: 120,
    timeLeft: 0,
    timerId: null,
    isLocked: false,
    isTimeUp: false,

    selectedOptionId: null,
    showSelectionError: false,

    score: 0,
    passPoints: 11,
  }),
  computed: {
    totalQuestions() {
      return this.examQuestions.length;
    },
    currentQuestion() {
      return this.examQuestions[this.currentIndex] || null;
    },
    progressPercent() {
      if (!this.totalQuestions) return 0;
      return Math.round(((this.currentIndex + 1) / this.totalQuestions) * 100);
    },
    percent() {
      if (!this.totalQuestions) return 0;
      return Math.round((this.score / this.totalQuestions) * 100);
    },
    passed() {
      return this.score >= this.passPoints;
    },
    timePercent() {
      return this.timeLeft / this.totalTime;
    },
    timeState() {
      if (this.timePercent <= 0.2) return "danger";
      if (this.timePercent <= 0.5) return "warning";
      return "normal";
    },
  },
  methods: {
    formatDateEs(dateObj) {
      const d = dateObj instanceof Date ? dateObj : new Date(dateObj);
      return d.toLocaleDateString("es-PE", { day: "2-digit", month: "long", year: "numeric" });
    },
    requiredRegistroOk(obj) {
      if (!obj) return false;
      const required = ["nombresApellidos", "correo", "telefono", "dni"];
      return required.every(k => (obj[k] ?? "") !== "");
    },
    redirectRegistro() {
      this.$router.replace("/voluntariado/escuela-observadores-democraticos/examen-pre-registro");
      return false;
    },
    loadRegistroOrRedirect() {
      const raw = sessionStorage.getItem("eod_exam_registro");
      if (!raw) return this.redirectRegistro();

      try {
        const parsed = JSON.parse(raw);
        if (!this.requiredRegistroOk(parsed)) throw new Error("Registro incompleto");
        this.registro = { ...this.registro, ...parsed };
        return true;
      } catch (e) {
        sessionStorage.removeItem("eod_exam_registro");
        return this.redirectRegistro();
      }
    },
    async showApiError(title) {
      return Swal.fire({
        title: title || "Ocurrió un problema",
        text: "No pudimos comunicarnos con el servidor. Intenta nuevamente en unos minutos.",
        icon: "error",
        confirmButtonText: "Reintentar",
        showCancelButton: true,
        cancelButtonText: "Volver",
        reverseButtons: true,
      });
    },
    async startExam() {
      this.finished = false;
      this.ready = false;
      this.currentIndex = 0;
      this.score = 0;
      this.answers = [];

      this.isLoading = true;
      this.loadingText = "Cargando preguntas...";

      try {
        const res = await this.$http.post(this.apiRoute("Exam", "Start"), { count: 20 });

        if (res.body?.error || !res.body?.result) {
          throw new Error(res.body?.message || "No se pudo iniciar el examen");
        }

        this.examQuestions = (res.body.data?.questions || []).map(q => ({
          id: q.id,
          prompt: q.prompt,
          options: q.options || []
        }));

        this.passPoints = res.body.data?.passPoints ?? 11;

        this.ready = true;
        this.startTimer();
      } catch (e) {
        const r = await this.showApiError("No se pudo cargar el examen");
        if (r.isConfirmed) return this.startExam();

        this.$router.replace("/voluntariado/escuela-observadores-democraticos/examen-pre-registro");
      } finally {
        this.isLoading = false;
        this.loadingText = "";
      }
    },
    pickRandomQuestions(bank, n) {
      const copy = bank.slice();
      for (let i = copy.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        const tmp = copy[i];
        copy[i] = copy[j];
        copy[j] = tmp;
      }
      return copy.slice(0, n);
    },
    startTimer() {
      this.clearTimer();

      this.timeLeft = this.totalTime;
      this.isLocked = false;
      this.isTimeUp = false;
      this.selectedOptionId = null;
      this.showSelectionError = false;

      this.timerId = setInterval(() => {
        this.timeLeft -= 1;
        if (this.timeLeft <= 0) {
          this.timeLeft = 0;
          this.onTimeUp();
        }
      }, 1000);
    },
    onTimeUp() {
      this.clearTimer();
      this.isLocked = true;
      this.isTimeUp = true;

      const qid = this.currentQuestion?.id;
      if (!qid) return;

      const already = this.answers.some(a => a.questionId === qid);
      if (already) return;

      this.answers.push({
        questionId: qid,
        optionId: this.selectedOptionId || null,
        timeUp: true
      });
    },
    confirmAnswer() {
      if (this.isLocked) return;

      if (!this.selectedOptionId) {
        this.showSelectionError = true;
        return;
      }

      const qid = this.currentQuestion?.id;
      const already = this.answers.some(a => a.questionId === qid);
      if (!already) {
        this.answers.push({
          questionId: qid,
          optionId: this.selectedOptionId,
          timeUp: false
        });
      }

      this.showSelectionError = false;
      this.isLocked = true;
      this.clearTimer();
      this.nextQuestion();
    },
    nextQuestion() {
      if (this.currentIndex < this.examQuestions.length - 1) {
        this.currentIndex += 1;
        this.selectedOptionId = null;
        this.startTimer();
        return;
      }

      this.finishExam();
    },
    async sendResultToSheets(result) {
      await fetch("https://script.google.com/macros/s/AKfycbxEg6XBNx1lNEBMmWO_hn0-jkmF1Au3qSoeE6gCil8MvkwXQMNWXFGooG-modu1b0xW/exec", {
        method: "POST",
        mode: "no-cors",
        headers: { "Content-Type": "text/plain" },
        body: JSON.stringify(result)
      });
    },
    async finishExam() {
      this.clearTimer();
      this.finished = false;
      this.ready = false;

      const now = new Date();
      const limaTime = now.toLocaleString("en-US", { timeZone: "America/Lima" });
      const localDate = new Date(limaTime);
      this.finishedAt = localDate;

      const qid = this.currentQuestion?.id;
      if (qid && !this.answers.some(a => a.questionId === qid) && this.selectedOptionId) {
        this.answers.push({
          questionId: qid,
          optionId: this.selectedOptionId,
          timeUp: false
        });
      }

      this.isLoading = true;
      this.loadingText = "Calculando tu resultado...";

      try {
        const finishRes = await this.$http.post(this.apiRoute("Exam", "Finish"), {
          answers: this.answers
        });

        if (finishRes.body?.error || !finishRes.body?.result) {
          throw new Error(finishRes.body?.message || "No se pudo finalizar el examen");
        }

        const data = finishRes.body.data || {};
        this.score = data.score ?? 0;
        this.passPoints = data.passPoints ?? this.passPoints;
      } catch (e) {
        const r = await this.showApiError("No se pudo finalizar el examen");
        if (r.isConfirmed) return this.finishExam();

        this.$router.replace("/voluntariado/escuela-observadores-democraticos/examen-pre-registro");
        return;
      } finally {
        this.isLoading = false;
        this.loadingText = "";
      }

      this.finished = true;

      const {
        nombresApellidos, correo, telefono, dni,
        region, provincia, distrito, regionExtranjero
      } = this.registro;

      const result = {
        nombresApellidos,
        correo,
        telefono,
        dni,
        region,
        provincia,
        distrito,
        regionExtranjero,
        score: this.score ?? 0,
        passed: this.passed,
        finishedAt: localDate.toISOString().replace("Z", "")
      };

      try {
        await this.sendResultToSheets(result);
      } catch (error) {
        console.error("Error al enviar los datos:", error);

        const r = await this.showApiError("No se pudo guardar los datos");
        if (r.isConfirmed) {
          try { await this.sendResultToSheets(result); } catch (e2) { console.error(e2); }
        }
      }
    },
    goBackToCert() {
      this.$router.push("/voluntariado/escuela-observadores-democraticos/examen-pre-registro");
    },
    clearTimer() {
      if (this.timerId) {
        clearInterval(this.timerId);
        this.timerId = null;
      }
    },
    restartExam() {
      this.finished = false;
      this.ready = false;
      this.score = 0;
      this.currentIndex = 0;
      this.selectedOptionId = null;
      this.showSelectionError = false;
      this.isLocked = false;
      this.isTimeUp = false;
      this.finishedAt = null;
      this.clearTimer();
      this.startExam();
    },
    async downloadConstancia() {
      try {
        const fullName =
          (this.registro && this.registro.nombresApellidos) ||
          "Participante Anónimo";

        const fecha = this.formatDateEs(this.finishedAt || new Date());

        const templateBytes = await fetch("/assets/files/Constancia-Examen-Capacitacion.pdf")
          .then((r) => r.arrayBuffer());

        const pdfDoc = await PDFDocument.load(templateBytes);

        const page = pdfDoc.getPages()[0];
        const { width } = page.getSize();

        const fontBold = await pdfDoc.embedFont(StandardFonts.HelveticaBold);
        const fontRegular = await pdfDoc.embedFont(StandardFonts.Helvetica);

        const nameColor = rgb(0.12, 0.25, 0.49);

        const nameFontSize = 20;
        const baseY = 300;
        const lineGap = 24;

        const cleanName = (fullName || "").trim().replace(/\s+/g, " ");

        const drawCentered = (text, y) => {
          const textWidth = fontBold.widthOfTextAtSize(text, nameFontSize);
          const x = (width - textWidth) / 2;
          page.drawText(text, {
            x,
            y,
            size: nameFontSize,
            font: fontBold,
            color: nameColor,
          });
        };

        const splitInTwoLines = (text) => {
          const words = text.split(" ");
          const mid = Math.ceil(words.length / 2);
          return [
            words.slice(0, mid).join(" "),
            words.slice(mid).join(" "),
          ];
        };

        if (cleanName.length > 60) {
          const [line1, line2] = splitInTwoLines(cleanName);
          drawCentered(line1, baseY + 24);
          drawCentered(line2, baseY + 24 - lineGap);
        } else {
          drawCentered(cleanName, baseY);
        }

        const dateFontSize = 11;
        const dateText = `${fecha}`;
        const dateX = 118;
        const dateY = 95;

        page.drawText(dateText, {
          x: dateX,
          y: dateY,
          size: dateFontSize,
          font: fontRegular,
          color: nameColor,
        });

        const pdfBytes = await pdfDoc.save();
        const blob = new Blob([pdfBytes], { type: "application/pdf" });

        const url = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = `Constancia_Capacitacion_${cleanName.replace(/\s+/g, "_")}.pdf`;
        document.body.appendChild(a);
        a.click();
        a.remove();
        URL.revokeObjectURL(url);

      } catch (error) {
        console.error("Error generando constancia:", error);
      }
    }
  },
  watch: {
    registro: {
      immediate: true,
      handler(val) {
        if (!val && !this.finished) {
          this.goBackToCert();
        }
      }
    },
    selectedOptionId(val) {
      if (val) {
        this.showSelectionError = false;
      }
    }
  },
  mounted() {
    if (!this.loadRegistroOrRedirect()) return;
    this.startExam();

    this._onBeforeUnload = () => sessionStorage.removeItem("eod_exam_registro");
    window.addEventListener("beforeunload", this._onBeforeUnload);
  },
  beforeDestroy() {
    this.clearTimer();
    sessionStorage.removeItem("eod_exam_registro");
    if (this._onBeforeUnload) {
      window.removeEventListener("beforeunload", this._onBeforeUnload);
    }
  }
};
</script>

<style scoped>
button:not(:disabled) {
  cursor: pointer;
}
.hourglass-flip {
  display: inline-block;
  transform-origin: center;
  animation: hourglassFlip 2s ease-in-out infinite;
}
@keyframes hourglassFlip {
  0%   { transform: rotate(0deg); }
  45%  { transform: rotate(0deg); }
  50%  { transform: rotate(180deg); }
  95%  { transform: rotate(180deg); }
  100% { transform: rotate(360deg); }
}
.time-badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 20px;
  border-radius: 8px;
  background: #eef6ff;
  color: #18417e;
  font-weight: 700;
}
.time-badge.normal {
  background: #eef6ff;
  color: #18417e;
}
.time-badge.warning {
  background: #fff3cd;
  color: #856404;
}
.time-badge.danger {
  background: #fdeaea;
  color: #dc3545;
}
.progress-bar {
  background-color: #18417e;
}
.exam-info-box {
  background-color: #f4f8fb;
  border-left: 4px solid #18417e;
  font-size: 14px;
}
.result-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 10px 18px;
  border-radius: 999px;
  font-weight: 800;
  letter-spacing: 0.04em;
  font-size: 14px;
}
.result-badge.ok {
  background: #eaf7ee;
  color: #1f7a3a;
  border: 1px solid #cfead8;
}
.result-badge.fail {
  background: #fdeaea;
  color: #b02a37;
  border: 1px solid #f6c9cf;
}
.result-stat {
  background: #ffffff;
  border: 1px solid #e9ecef;
  border-radius: 12px;
  padding: 14px 12px;
}
.result-stat .label {
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #6c757d;
  margin-bottom: 4px;
}
.result-stat .value {
  font-size: 18px;
  font-weight: 800;
  color: #1f2d3d;
}
</style>
